import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import PrivateRoutes from './components/utils/PrivateRoutes';
import AuthProvider from './providers/AuthProvider';
import Navbar from './components/common/Navbar';
import Home from './components/pages/home/Home';
import Footer from './components/common/Footer';
import Contact from './components/pages/Contact';
import SignUp from './components/pages/auth/SignUp';
import ForgotPassword from './components/pages/auth/ForgotPassword';
import OtpPage from './components/pages/auth/OtpPage';
import About from './components/pages/About';
import TermsAndConditions from './components/pages/TermsAndConditions';
import CategoriesProvider from './providers/CategoriesProvider';
import BannersProvider from './providers/BannersProvider';
import ResetPassword from './components/pages/auth/ResetPassword';
import ProductProvider from './providers/ProductProvider';
import ContactsProvider from './providers/ContactProvider';
import ShippingAndDelivery from './components/pages/ShippingAndDelivery';
import CancellationAndRefund from './components/pages/CancellationAndRefund';
import MyProfile from './components/pages/user/MyProfile';
import CategoryProducts from './components/pages/categories/CategoryProducts';
import ScrollToTop from './components/utils/ScrollToTop';
import Address from './components/pages/user/Address';
import AddAddress from './components/pages/user/AddAddress';
import Cart from './components/pages/Cart';
import UpdateAddress from './components/pages/user/UpdateAddress';
import CartProvider from './providers/CartProvider';
import Shop from './components/pages/Shop';
import MyOrders from './components/pages/MyOrders';
import CheckOut from './components/pages/CheckOut';
import Search from './components/pages/Search';
import AuthHome from './components/pages/auth/AuthHome';
import CategoryHome from './components/pages/categories/CategoryHome';
import Wishlist from './components/pages/Wishlist';
import { useEffect } from 'react';
import CollectionsProvider from './providers/CollectionsProvider';
import ProductDetails from './components/pages/productDetails/ProductDetails';
import WishListProvider from './providers/WishListProvider';
import AllCollections from './components/pages/collections/AllCollections';
import CollectionProducts from './components/pages/collections/CollectionProducts';
import PayForOrder from './components/PayForOrder';
import HomeCustomizationProvider from './providers/HomeCustomizationProvider';
import ProductsSearch from './components/pages/ProductsSearch';
import CancelConfirm from './components/pages/CancelConfirm';
import GoogleAnalytics from './GoogleAnalytics';
import AOS from "aos";
import "aos/dist/aos.css";
import OrderDetails from './components/pages/OrderDetails';

function App() {

  useEffect(() => {
    AOS.init({
      once: true,
      // disable: "phone",
      duration: 700,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <AuthProvider key={'authprovider'}>
      <Router>
        <CategoriesProvider>
          <CollectionsProvider>
            <BannersProvider>
              <ProductProvider>
                <CartProvider>
                  <WishListProvider>
                    <ContactsProvider>
                      <HomeCustomizationProvider>
                        <ScrollToTop />
                        <GoogleAnalytics trackingId="G-L4S0D3GSQ7" />
                        <Navbar />
                        <Routes>
                          <Route element={<PrivateRoutes />}>
                            <Route path='/my-profile' element={<MyProfile />} />
                            <Route path='/orders' element={<MyOrders />} />
                            <Route path='/addresses' element={<Address />} />
                            <Route path='/address/add' element={<AddAddress />} />
                            <Route path='/address/update' element={<UpdateAddress />} />
                            <Route path='/cart' element={<Cart />} />
                            <Route path='/checkout' element={<CheckOut />} />
                            <Route path='/wishlist' element={<Wishlist />} />
                            <Route path='/pay' element={<PayForOrder />} />
                            <Route path='/order-details' element={<OrderDetails />} />
                            <Route path='/cancel-confirm' element={<CancelConfirm />} />
                          </Route>
                          <Route path='/' element={<Home />} />
                          <Route path='/login' element={<AuthHome />} />
                          <Route path='/signup' element={<SignUp />} />
                          <Route path='/forgot-password' element={<ForgotPassword />} />
                          <Route path='/otp-page' element={<OtpPage />} />
                          <Route path='/reset-password' element={<ResetPassword />} />
                          <Route path='/categories' element={<CategoryHome />} />
                          <Route path='/collections' element={<AllCollections />} />
                          <Route path='/collections/:id' element={<CollectionProducts />} />
                          <Route path='/categories/:slug' element={<CategoryProducts />} />
                          <Route path='/products-search' element={<ProductsSearch />} />
                          {/* TEMP :  */}
                          <Route path='/product/:slug' element={<ProductDetails />} />
                          <Route path='/contact' element={<Contact />} />
                          <Route path='/about' element={<About />} />
                          <Route path='/shop' element={<Shop />} />
                          <Route path='/search' element={<Search />} />
                          {/* <Route path='/festival' element={<Festival />} /> */}
                          {/* <Route path='/cancellation-and-refunds' element={<ReturnsRefunds />} /> */}
                          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
                          <Route path='/cancellation-and-refunds' element={<CancellationAndRefund />} />
                          <Route path='/shipping-policy' element={<ShippingAndDelivery />} />
                        </Routes>
                      </HomeCustomizationProvider>
                      <Footer />
                      <ToastContainer position='bottom-center' autoClose='1500' />
                    </ContactsProvider>
                  </WishListProvider>
                </CartProvider>
              </ProductProvider>
            </BannersProvider>
          </CollectionsProvider>
        </CategoriesProvider>
      </Router>
    </AuthProvider >
  );
}

export default App;